module.exports = __webpack_public_path__ + "static/media/default-user.e7045bba.svg";